import React, { useState, useEffect, ChangeEvent, useContext } from "react";
import CardInfo from "./CardInfo";
import AddNewContactForm from "./AddNewContactForm";
import { Container, Modal, ModalHeader } from "reactstrap";
import {
  getDisplayPhoneNumber,
  getDisplayValue,
  sendPhondNumberFormat,

} from "../../utils/GeneralUtils";
import { leadContactdetails } from "./LeadContact";
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";
import EditContactForm from "./EditContactForm";
import circleCheck from "./../../images/circle-check-regular.svg";
import fillcircleCheck from "./../../images/check-circle-fill-color.svg";
import { toast } from "react-toastify";
import { catchError } from "../../utils/Utils";
import { AxiosError } from "axios";
import Service from "../../services";
import { ReactComponent as UserIcon } from "../../images/user.svg";
import RoleAuthorization from "../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";
import { TriggerContext } from "../../Context/TriggerContext";


// type EmailType = {
//   email: string;
//   emailType?: string;
// };

// type PhoneType = {
//   phone: string;
//   phExt?: string;
//   phoneType?: string;
// };

type data = {
  firstName: string;
  lastName: string;
  title: string;
  dob: string;
  streetAddress: string;
  unitSuite: string;
  city: string;
  businesszipCode: string;
  email: string;
  phone: number;
  emailType: string;
  phoneType: string;
  phExt: string;
  state: string;
  zipcode: number;
  P?: boolean;
};

const AddNewContactCards = (props: any) => {
  const [addNewContactOpen, setNewAddNewContactOpen] = useState(false);
  const [editLeadContact, setEditLeadContact] = useState<any>({});
  const [editLeadContactOpen, setEditLeadContactOpen] = useState(false);

  const [clickedCardIndex, setClickedCardIndex] = useState(-1); // Initialize with -1
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(4);
  const [isCardClicked, setIsCardClicked] = useState(false);
  const [firstSet, setFirstSet] = useState("firstSet");
  // const [isPrimary, setIsPrimary] = useState(false);
  const [transformValue, setTransformValue] = useState<number>(5);
  const triggerContext = useContext(TriggerContext);
  const [editPrimarycontact, setEditPrimarycontact] = useState<boolean>(true);

  const {
    leadData,
    msgButton,
    addNewContactBtn,
    editContactBtn,
    searchItem,
    placeholder,
    selectBtn,
    clientId,
    productId,
    parentClientId,
    clientProductsContactMappingId,
    presentLead
  } = props;
  const service = new Service();

  /*  */

  // Calculate the index of the last item (assuming 0-based indexing)
  const lastIndex = leadData?.length - 1;

  // Calculate the transform value for the last item

  const calculatedTransformValue =
    isCardClicked && activeCardIndex < lastIndex
      ? lastIndex * hoveredCardIndex
      : (lastIndex + 1) * hoveredCardIndex;
  // Set the transform value in the state
  // Ensure that setTransformValue is called conditionally
  if (transformValue !== calculatedTransformValue && leadData?.length > 1) {
    setTransformValue(calculatedTransformValue);
  }
  const handleCardClick = (index: React.SetStateAction<number>) => {
    setFirstSet("");
    setClickedCardIndex(index); // Store the clicked index
    setActiveCardIndex(index); // Set the clicked card as active
    setIsCardClicked(true); // Set the flag to true after clicking a card
    setHoveredCardIndex(5);
  };
  const handleCardMouseOver = (
    index: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    setHoveredCardIndex(9);
  };

  const handleContactCardMouseOut = () => {
    setHoveredCardIndex(4);
  };
  const handleCardMouseOut = () => {
    setHoveredCardIndex(4);
  };

  const addNewContact = () => {
    setNewAddNewContactOpen(!addNewContactOpen);
  };

  const getSelectedClientContactId = (id: string, isPrimaryVal: boolean) => {
    props.clientContactId(id, isPrimaryVal);
  };

  const editContact = (row: any) => {
    if (row.dob && !new Date(row.dob).getTime()) {
      row.dob = "";
    }
    setEditPrimarycontact(row.primary)
    setEditLeadContact(row);
    setEditLeadContactOpen(true);
  };
  const editContactToggle = () => {
    setEditLeadContactOpen(!editLeadContactOpen);
  };

  const handleFormSubmit = (values: any) => {
    triggerContext?.setValue(true);
    const saveContactData = {
      sections: "createClientContact",
      clientId: clientId,
      clientProductsId: productId,
      clientProductsContactMappingId: clientProductsContactMappingId,
      data: {
        clientId: clientId,
        firstName: values?.firstName,
        lastName: values?.lastName,
        title: values?.title,
        dob: values?.dob,
        streetAddress: values?.streetAddress,
        unitSuite: values?.unitSuite,
        city: values?.city,
        state: values?.state,
        zipCode: values?.zipCode,
        email: values?.email,
        emailType: values?.emailType,
        phoneNumber: sendPhondNumberFormat(values?.phoneNumber),
        phoneExt: values?.phoneExt,
        phoneType: values?.phoneType,
        isPrimary: values?.isPrimary,
        parentClientId: parentClientId || clientId,
      },
    };
    service
      .saveOrUpdateContactCard(saveContactData)
      .then(() => {
        addNewContact();
        props.getLeadData();       
        props?.getAllContacts();


        toast.success("Save Contact Successfully..!!");
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  let timer: any;
  const getSearchContactDetails = (event: ChangeEvent<HTMLInputElement>) => {
    // searchItem(event.target.value);
    const s = event.target.value;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => props?.getAllContacts(s), 300);
  };

  return (
    <div className="lead-contactcrad">
      <div className="contact-search">
        <input
          type="search"
          className="searchContacts form-control"
          placeholder="Search Contacts"
          onChange={(e) => getSearchContactDetails(e)}
        />
      </div>
      <div
        className="contact-card"
        onMouseOver={(index) => handleCardMouseOver(index)}
        onMouseOut={handleContactCardMouseOut}
      // style={{ paddingTop: `${transformValue}%` }}
      >
        {leadData !== undefined && leadData?.length > 0 ? (
          leadData?.map((leadContact: leadContactdetails, index: number) => (
            <div
              className={`rolodex-card contactContainer  ${firstSet} ${index + 1
                } ${activeCardIndex === index ? "active" : ""}`}
              onClick={() => handleCardClick(index)}
              key={index}
              style={{
                transform: `translateY(-${isCardClicked && activeCardIndex < index
                  ? index * hoveredCardIndex
                  : (index + 1) * hoveredCardIndex
                  }%)`,
                zIndex: clickedCardIndex === index ? 1 : 1000 - index,
              }}
            >                      
            <Card  className={`${(leadContact?.productName==="Lüt" && leadContact?.primary===true) ? "lutCard-header": "card"}`}>
              {(leadContact?.productName==="Lüt" && leadContact?.primary===true) ?<div className="headerofhousehold">HEAD OF HOUSEHOLD</div>:""}
               <CardHeader>      
                  <Container className="rolodex-headers">
                    <Row>
                      <Col md={8} className="d-flex user-thumb-wrap">
                        <div className={`${(leadContact?.productName==="Lüt" && leadContact?.primary===true)?"user-lutthumb":"user-thumb"}`}>
                          <UserIcon />
                        </div>
                        <div className="lead-name-wrap">
                          <h6 className="lead-name">
                            {[leadContact?.firstName, leadContact?.lastName]
                              .join(" ")
                              .trim()}
                          </h6>
                          <span className="lead-title">
                            {leadContact?.title}
                          </span>
                        </div>
                      </Col>
                      <Col md={4}>
                        {
                          RoleAuthorization(Pages.customerDetailsPage, actionAuthorization.editRolodex) && !triggerContext?.readOnlyMode &&
                          <div
                            className="edit"
                            onClick={() => editContact(leadContact)}
                          >
                            Edit
                          </div>}
                        <div>
                          {clientProductsContactMappingId ? (clientProductsContactMappingId === leadContact?.clientProductsContactMappingId ? (
                            <div className="primay">Primary</div>
                          ) : (
                            ""
                          )) : ""}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </CardHeader>
                <CardBody>
                  <Container>
                    <Row>
                      <Col>
                        <Row className="label">
                          Email <span className="badge badge-light"></span>
                        </Row>
                        <Row className="label-text">{leadContact?.email}</Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <Row className="label">Work Phone</Row>
                        <Row className="label-text">
                          {leadContact?.phoneNumber || leadContact?.phone}
                          {leadContact?.phoneExt !== null ? (
                            <span className="extdata">
                              &nbsp;&nbsp;ext&nbsp;
                              <span className="">
                                {leadContact?.phoneExt}
                              </span>
                            </span>
                          ) : (
                            ""
                          )}

                        </Row>
                      </Col>
                      <Col md="4">
                        <Row className="label">Cell Phone</Row>
                        <Row className="label-text">
                          {" "}
                          {leadContact.cellPhone}
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <Row className="label">Address</Row>
                        <Row className="label-text">
                          <Row>
                            {" "}
                            {leadContact?.streetAddress !== null
                              ? leadContact?.streetAddress
                              : "--"}
                          </Row>
                          <Row>
                            {" "}
                            {leadContact?.unitSuite !== null
                              ? leadContact?.unitSuite
                              : ""}
                          </Row>
                          <Row>
                            {leadContact?.city ||
                              leadContact?.state ||
                              leadContact?.zipcode
                              ? (leadContact?.city !== null
                                ? leadContact?.city
                                : "") +
                              " " +
                              (leadContact?.state !== null
                                ? leadContact?.state
                                : "") +
                              " " +
                              (leadContact?.zipCode !== null
                                ? leadContact?.zipCode
                                : "")
                              : "- - "}
                          </Row>

                          {/* {[leadContact?.streetAddress ||
                          leadContact?.city ||
                          leadContact?.state ||
                          leadContact?.zipcode||leadContact?.unitSuite].filter((v:any) =>v).map((v2:any)=><div>{v2}</div>)} */}
                        </Row>
                      </Col>

                      <Col md="4">
                        <Row className="label">DOB</Row>
                        <Row className="label-text">{leadContact.dob}</Row>
                      </Col>
                    </Row>
                    {/* 
                    {msgButton && (
                      <div className="message">
                        <div className="Message-button">Message</div>
                      </div>
                    )} */}
                    {selectBtn && (
                      <button
                        className="selectButton"
                        type="button"
                        onClick={() =>
                          getSelectedClientContactId(
                            leadContact.clientContactId,
                            leadContact?.isPrimary
                          )
                        }
                      >
                        Select
                      </button>
                    )}
                  </Container>
                </CardBody>
              </Card>
            </div>
          ))
        ) : (
          <div>
            <h6 className="norecords not-found">No records found</h6>
          </div>
        )}
      </div>

      {
        addNewContactBtn && RoleAuthorization(Pages.customerDetailsPage, actionAuthorization.createContactRolodex) && !triggerContext?.readOnlyMode &&
        (
          <div className="newcontact">
            <div className="add-newcontact" onClick={addNewContact}>
              Add New Contact
            </div>
          </div>
        )}

      <Modal
        className="add-newcontact-modal"
        isOpen={addNewContactOpen}
        toggle={addNewContact}
      >
        <ModalHeader toggle={addNewContact}>
          <div className="contact-header">
            {" "}
            <span className="header"> New Contact</span>
          </div>
        </ModalHeader>

        <AddNewContactForm
          closeModal={() => {
            setNewAddNewContactOpen(false);
          }}
          title={"Add New Contact"}
          handleFormSubmit={handleFormSubmit}
          refreshLeads={props?.getAllContacts}
          getLeadData={props?.getLeadData}
        />
      </Modal>
      <Modal
        className="add-newcontact-modal"
        isOpen={editLeadContactOpen}
        toggle={editContactToggle}
      >
        <ModalHeader toggle={editContactToggle}>
          <div className="contact-header">
            <span className="header"> Edit Contact</span>
          </div>
        </ModalHeader>
        <EditContactForm
          closeModal={() => {
            setEditLeadContact({});
            setEditLeadContactOpen(false);
          }}
          title={"Edit Contact"}
          handleFormSubmit={handleFormSubmit}
          getLeadData={props?.getLeadData}
          refreshLeads={props?.getAllContacts}
          data={editLeadContact}
          clientId={clientId}
          productId={productId}
          clientProductsContactMappingId={clientProductsContactMappingId}
          parentClientId={parentClientId || clientId}
          editPrimarycontact={editPrimarycontact}
        />
      </Modal>
    </div>
  );
};

export default AddNewContactCards;
